export enum WaybillTitleType {

    Undefined = "Undefined",
    Title1 = "Title1",
    Title2 = "Title2",
    Title3 = "Title3",
    Title4 = "Title4",
    Title5 = "Title5",
    Title6 = "Title6",
    T1NoC = "T1NoC",

}



/** Подписи для колонки «Титул» (значения приходят с API как строки enum). */
export const WaybillTitleTypeUtil = {

    getLabel: (value: WaybillTitleType | string | null | undefined): string => {

        switch (value) {

            case WaybillTitleType.Title1:
                return "Титул 2";

            case WaybillTitleType.Title2:
                return "Титул 2";

            case WaybillTitleType.Title3:
                return "Титул 3";

            case WaybillTitleType.Title4:
                return "Титул 4";

            case WaybillTitleType.Title5:
                return "Титул 6";

            case WaybillTitleType.Title6:
                return "Титул 6";

            case WaybillTitleType.T1NoC:
                return "Уточнение (T1NoC)";

            case WaybillTitleType.Undefined:
            default:
                return "Неизвестно";

        }

    },

};

